import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActionMenuComponent } from './action-menu.component';

@Injectable({ providedIn: 'root' })
export class ActionMenuService {
  public actionMenu: ActionMenuComponent = null;
  public item: any = null;

  constructor() {}
}
